import axios from 'axios'
import store from '@/store'
import sign from '@/assets/js/sign'

// 请求发起前拦截器
axios.interceptors.request.use(
  config => {
    if (Object.keys(config.headers).includes('X-Protocol-Id')) {
      return config
    }
    var signValues = sign(config)
    if (process.env.NODE_ENV !== 'production') {
      // console.log(signValues)
    }

    config.headers = {
      ...config.headers,
      ...signValues,
      'Ykt-Token': store.state.auth.loginInfo
        ? store.state.auth.loginInfo.token
        : ''
    }
    return config
  },
  error => {
    // 异常处理
    return Promise.resolve({
      result: {
        code: -100,
        error
      }
    })
  }
)

// 响应拦截
axios.interceptors.response.use(
  ({ data }) => {
    // 这里返回的 response.data 是被 axios 包装过的一成，所以在这里抽取出来
    // 22200 token失效  22208未登录
    if (data.result.code === 22200 || data.result.code === 22208) {
      store.dispatch('auth/logout')
    }
    return data
  },
  error => {
    return Promise.resolve({
      result: {
        code: -100,
        error
      }
    })
  }
)

// 导出
export default axios
